import { defineComponent as _defineComponent } from 'vue'
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { ECBasicOption } from 'echarts/types/dist/shared';
import {
    PieChart,
    GaugeChart,
    BarChart,
    HeatmapChart,
    LineChart,
    RadarChart,
} from 'echarts/charts';
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    VisualMapComponent,
} from 'echarts/components';
import VChart, { THEME_KEY } from 'vue-echarts';
import { nextTick, onBeforeUnmount, onMounted, PropType, provide, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiChart',
  props: {
    option: {
        type: Object as PropType<ECBasicOption>,
    },
    autoresize: {
        type: Boolean,
        default: true,
    },
    height: {
        type: String,
        default: '320px',
    },
},
  emits: ["mouseover", "mouseout", "click"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

use([
    CanvasRenderer,
    PieChart,
    BarChart,
    GaugeChart,
    HeatmapChart,
    LineChart,
    RadarChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    VisualMapComponent,
]);

provide(THEME_KEY, 'light');

const props = __props;

const emit = __emit;

const containerRef = ref<HTMLElement | null>(null);
const isReady = ref(false);
let resizeObserver: ResizeObserver | null = null;
let animationFrame: number | null = null;

const scheduleReadinessCheck = () => {
    if (animationFrame !== null) return;

    animationFrame = window.requestAnimationFrame(() => {
        animationFrame = null;
        const container = containerRef.value;
        if (!container) return;

        const isVisible = container.clientWidth > 0 && container.clientHeight > 0;
        if (!isVisible) return;

        isReady.value = true;
        resizeObserver?.disconnect();
        resizeObserver = null;
    });
};

onMounted(async () => {
    await nextTick();
    resizeObserver = new ResizeObserver(scheduleReadinessCheck);
    if (containerRef.value) resizeObserver.observe(containerRef.value);
    scheduleReadinessCheck();
});

onBeforeUnmount(() => {
    resizeObserver?.disconnect();
    if (animationFrame !== null) window.cancelAnimationFrame(animationFrame);
});

const __returned__ = { props, emit, containerRef, isReady, get resizeObserver() { return resizeObserver }, set resizeObserver(v) { resizeObserver = v }, get animationFrame() { return animationFrame }, set animationFrame(v) { animationFrame = v }, scheduleReadinessCheck, get VChart() { return VChart } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})